import { BaseDto } from './base.dto';
import { DeviceDto } from './device.dto';

export enum AlarmRuleActionType {
  EMAIL = 'email',
  /* WEBHOOK = 'webhook',*/
  DEVICE_UPDATE = 'deviceUpdate',
  CREATE_ALARM = 'createAlarm',
  ALARM_RESOLVED = 'alarmResolved',
}

export interface AlarmRuleActionDto extends BaseDto {
  alarm_rule_id: number;
  type: AlarmRuleActionType;
  config: string | Record<string, unknown> | AlarmRuleActionEmailConfig | AlarmRuleActionWebhookConfig | AlarmRuleActionDeviceUpdateConfig | AlarmRuleActionResolvedAlarm;
  overrideConfig?: Record<string, unknown>;
}

export interface AlarmRuleActionEmailConfig {
  to?: string[];
  // subject?: string;
  // body?: string;
}

export interface AlarmRuleActionWebhookConfig {
  url: string;
  body?: string;
}

export interface AlarmRuleActionDeviceUpdateConfig {
  update: Partial<DeviceDto>;
}

export interface AlarmRuleActionUpdateDto {
  id?: number;
  type: AlarmRuleActionType;
  config: {} | AlarmRuleActionEmailConfig | AlarmRuleActionWebhookConfig | AlarmRuleActionDeviceUpdateConfig;
}

export interface AlarmRuleActionResolvedAlarm {
  alarmType?: string;
}